import React from 'react';
import { motion } from 'framer-motion';
import { Download } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  subtext?: string;
  href?: string;
}
export function CTAButton({
  text,
  subtext,
  href = 'https://www.novantumnexus.com/cart/53886965678355:1'
}: CTAButtonProps) {
  return <div className="flex flex-col items-center w-full max-w-md mx-auto" data-id="element-155">
      <motion.a href={href} whileHover={{
      scale: 1.04,
      boxShadow: '0 0 40px rgba(30, 144, 255, 0.5), 0 0 80px rgba(30, 144, 255, 0.2)'
    }} whileTap={{
      scale: 0.97
    }} animate={{
      boxShadow: ['0 0 20px rgba(30, 144, 255, 0.3), 0 0 40px rgba(30, 144, 255, 0.1)', '0 0 30px rgba(30, 144, 255, 0.5), 0 0 60px rgba(30, 144, 255, 0.2)', '0 0 20px rgba(30, 144, 255, 0.3), 0 0 40px rgba(30, 144, 255, 0.1)']
    }} transition={{
      boxShadow: {
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }
    }} className="relative w-full block text-center bg-gradient-to-r from-[#1a56db] via-[#2563eb] to-[#3b82f6] hover:from-[#2563eb] hover:via-[#3b82f6] hover:to-[#60a5fa] text-white rounded-xl px-8 py-4 font-bold transition-all duration-300 border border-white/10 overflow-hidden" data-id="element-156">
        <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/15 to-transparent -skew-x-12" animate={{
        x: ['-200%', '200%']
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut',
        repeatDelay: 1
      }} data-id="element-157" />
        <span className="relative flex items-center justify-center gap-3 font-[800] tracking-wide text-[20px]" data-id="element-158">
          <Download size={26} strokeWidth={3} data-id="element-159" />
          DESCARGAR AHORA
        </span>
      </motion.a>
      {subtext}
    </div>;
}